<template>
  <SectionWrapper sectionId="approach">
    <SectionContainer>
      <Heading :titleImgSrc="headingData.img" :titleText="headingData.text" :leading="headingData.leading" :description="headingData.description" />
      <ContentContainer>
        <img class="approach_img" :src="approachImg" loading="lazy" alt="新しいプロダクト開発へのアプローチ法">
        <!-- <div class="approach_description">
          <p>ほげほげ</p>
        </div> -->
        <div class="approach_button">
          <LinkButton href="https://www.ctc-g.co.jp/keys/download/build-service" color="purple" shape="border">資料ダウンロード</LinkButton>
          <LinkButton href="https://www.ctc-g.co.jp/solutions/build_sales/" color="purple" shape="solid">詳細はこちら</LinkButton>
        </div>
      </ContentContainer>
    </SectionContainer>
  </SectionWrapper>
</template>

<script>
import Heading from '../atoms/Heading'
import SectionWrapper from '../atoms/SectionWrapper'
import SectionContainer from '../atoms/SectionContainer'
import ContentContainer from '../atoms/ContentContainer'
import LinkButton from '../atoms/LinkButton'
import approachImg from '../../assets/images/approach.svg'

export default {
  name: 'approach',
  components: {
    Heading,
    SectionWrapper,
    SectionContainer,
    ContentContainer,
    LinkButton
  },
  data () {
    return {
      approachImg,
      headingData: {
        img: require('@/assets/images/title_approach.svg'),
        text: 'approach',
        leading: '進め方を知る',
        description: 'デザインとエンジニアリング、アジャイルをベースにしたスタートアップのアプローチをエンタープライズに適用\n探索・実装・発展すべてのプロセスにおいて、お客様チームの一員として伴走します'
      }
    }
  }

}
</script>

<style scoped lang="scss">
.approach {
  &_img {
    width: 100%;
  }
  &_button {
    margin-top: 64px;
    display: flex;
    justify-content: center;
    gap: 88px;
  }
  &_description {
    margin: 30px;
    margin-top: 70px;
    p {
      padding: 20px;
      border: 1px solid;
      height: 100px;
    }
  }
}
</style>
